import React from 'react';
import { LegalPage, LegalSection } from './LegalPage';
const LAST_UPDATED = 'June 24, 2026';
const sections: LegalSection[] = [{
  heading: 'Acceptance of Terms',
  body: ['These Terms of Service govern your use of the 206Gravel website and your purchase of materials and delivery services from us. By using the site or placing an order, you agree to these terms.']
}, {
  heading: 'Orders & Pricing',
  bullets: ['Prices, delivery fees, and availability are shown per yard and per delivery zone and may change without notice.', 'Quotes and on-site estimates are approximate. Final pricing is confirmed when your order is placed.', 'We reserve the right to refuse or cancel an order, including for pricing errors or material availability.']
}, {
  heading: 'Delivery',
  bullets: ['Delivery windows are estimates and may shift due to weather, road conditions, or dispatch volume.', 'You are responsible for providing safe, legal, and accessible drop locations. Our drivers will not place material where it could cause damage or violate access rules.', 'If a site is inaccessible on arrival, a trip or re-delivery fee may apply.']
}, {
  heading: 'Material Estimates & Coverage',
  body: ['Our calculators and coverage figures are provided as guidance only. Actual material needs vary by site conditions, compaction, and depth. 206Gravel is not responsible for over- or under-ordering based on these estimates.']
}, {
  heading: 'Payments',
  body: ['Payment is due as specified at the time of order. By providing payment information you represent that you are authorized to use the selected payment method.']
}, {
  heading: 'Cancellations & Refunds',
  body: ['Order changes, cancellations, and refunds are governed by our Refund & Return Policy, which forms part of these terms.']
}, {
  heading: 'Limitation of Liability',
  body: ['To the fullest extent permitted by law, 206Gravel is not liable for indirect, incidental, or consequential damages arising from the use of our site, materials, or delivery services. Our total liability for any claim will not exceed the amount you paid for the order in question.']
}, {
  heading: 'Changes to These Terms',
  body: ['We may update these terms from time to time. Continued use of the site after changes are posted constitutes acceptance of the revised terms.']
}, {
  heading: 'Contact Us',
  body: ['Questions about these terms? Call (206) 619-3742 or email info@206gravel.com.']
}];
export function TermsOfService() {
  return <LegalPage title="Terms of Service" intro="The terms that apply when you use the 206Gravel website and order material delivery." lastUpdated={LAST_UPDATED} sections={sections} data-id="element-3390" data-mp="2g4kg9ou0nd26" />;
}